"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppearIn = exports.BounceOut = exports.BounceIn = exports.FadeIn = exports.ScaleIn = exports.ScaleInX = exports.ScaleInY = exports.SlideInFromRight = exports.SlideInFromLeft = exports.SlideInFromTop = exports.FadeInFromTop = void 0;

var _styledComponents = require("styled-components");

/* Default bounce: cubic-bezier(0.175, 0.885, 0.32, 1.275) */
var FadeInFromTop = (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateY(-100%);}to{opacity:1;transform:translateY(0);}"]);
exports.FadeInFromTop = FadeInFromTop;
var SlideInFromTop = (0, _styledComponents.keyframes)(["from{transform:translateY(-100%);}to{transform:translateY(0);}"]);
exports.SlideInFromTop = SlideInFromTop;
var SlideInFromLeft = (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateX(-100%);}to{opacity:1;transform:translateX(0);}"]);
exports.SlideInFromLeft = SlideInFromLeft;
var SlideInFromRight = (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateX(100%);}to{opacity:1;transform:translateX(0);}"]);
exports.SlideInFromRight = SlideInFromRight;
var ScaleInY = (0, _styledComponents.keyframes)(["from{transform:scaleY(0);}to{transform:scaleY(1);}"]);
exports.ScaleInY = ScaleInY;
var ScaleInX = (0, _styledComponents.keyframes)(["from{transform:scaleX(0);}to{transform:scaleX(1);}"]);
exports.ScaleInX = ScaleInX;
var ScaleIn = (0, _styledComponents.keyframes)(["from{transform:scale(0);}to{transform:scale(1);}"]);
exports.ScaleIn = ScaleIn;
var FadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
exports.FadeIn = FadeIn;
var BounceIn = (0, _styledComponents.keyframes)(["from{opacity:0;transform:translateY(-12px);}to{opacity:1;transform:translateY(0);}"]);
exports.BounceIn = BounceIn;
var BounceOut = (0, _styledComponents.keyframes)(["from{opacity:1;transform:translateY(0);}to{opacity:0;transform:translateY(-12px);}"]);
exports.BounceOut = BounceOut;
var AppearIn = (0, _styledComponents.keyframes)(["from{transform:translateX(-100px);}to{transform:translateX(0);}"]);
exports.AppearIn = AppearIn;